/**
 * 编辑器脏检查：两份 JSON 是否相同。工作副本按不可变方式更新（components/novel/pack-model.js 的 writePath），
 * 未改动的分支与基线是同一引用，这里遇到同一引用直接判相同，所以每次只往下比改动过的路径，不再序列化整本。
 */
export function sameJson(a, b) {
  if (a === b) return true
  if (a === null || b === null || typeof a !== 'object' || typeof b !== 'object') return false
  if (Array.isArray(a) !== Array.isArray(b)) return false
  const keys = Object.keys(a)
  if (keys.length !== Object.keys(b).length) return false
  for (const key of keys) {
    if (!Object.hasOwn(b, key) || !sameJson(a[key], b[key])) return false
  }
  return true
}
